const getFromLocalStorage = <T = string>(key: string) => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
      const parsed: T = JSON.parse(item);
      return parsed;
    } catch {
      return item;
    }
  } catch {
    return null;
  }
};

export default getFromLocalStorage;
